<template>
  <div class="patent-page">
    <Header type="black" />
    
    <div class="patent-content" v-if="patent">
      <h1 class="p-title">{{ patent.title }}</h1>
      
      <div class="p-row">
        <div class="p-box p-desc">
          <h3>Patent Açıklaması</h3>
          <p>{{ patent.description }}</p>
        </div>
        <div class="p-box p-img-box" v-if="patent.image">
          <img :src="patent.image" alt="Patent Görseli" />
        </div>
      </div>

      <div class="p-link-container" v-if="patent.link">
        <a :href="patent.link" target="_blank" class="p-link-btn">Patent Bağlantısı (Tıklanabilir)</a>
      </div>

      <div class="p-row" v-if="patent.extraImage || patent.extraDescription">
        <div class="p-box p-img-box" v-if="patent.extraImage">
          <img :src="patent.extraImage" alt="Artı Görsel" />
        </div>
        <div class="p-box p-desc" v-if="patent.extraDescription">
          <h3>Artı Açıklama</h3>
          <p>{{ patent.extraDescription }}</p>
        </div>
      </div>

      <h2 class="p-sub" v-if="patent.techSpecs">Teknik Özellikleri</h2>
      <div class="p-box p-tech" v-if="patent.techSpecs">
        <ul>
          <li v-for="(spec, i) in patent.techSpecs.split('\n')" :key="i">{{ spec }}</li>
        </ul>
      </div>
    </div>
    
    <div class="patent-content" v-else-if="loading" style="color:white; text-align:center;">Yükleniyor...</div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/common/Header.vue";
import Footer from "../components/common/Footer.vue";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getApp } from "firebase/app";

export default {
  components: { Header, Footer },
  data() { return { patent: null, loading: true }; },
  async mounted() {
    window.scrollTo(0, 0);
    try {
      const db = getFirestore(getApp());
      const pId = this.$route.params.id;
      const docRef = doc(db, "patentler", pId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) { 
        const data = docSnap.data();
        // GÜVENLİK: Eğer içi tamamen boş bir patente direkt linkle/F5 ile girilirse "çok yakında" ekranına at!
        if (!data.description && !data.techSpecs && !data.image && !data.extraImage && !data.extraDescription) {
          this.$router.push(`/${this.$i18n.locale}/coming-soon`);
        } else {
          this.patent = data; 
        }
      } else {
         this.$router.push(`/${this.$i18n.locale}/404`);
      }
    } catch (e) { console.error(e); } finally { this.loading = false; }
  }
};
</script>

<style scoped>
.patent-page { background-color: #000; min-height: 100vh; color: #fff; font-family: 'DM Sans', sans-serif; padding-top:100px; }
.patent-content { max-width: 1200px; margin: 0 auto; padding: 50px 20px; }
.p-title { text-align: center; font-size: 36px; margin-bottom: 50px; font-weight: bold; }
.p-row { display: flex; gap: 30px; margin-bottom: 40px; }
.p-box { border: 2px solid #fff; padding: 30px; flex: 1; display: flex; flex-direction: column; justify-content: center; }
.p-desc h3 { margin-top:0; font-size:22px; margin-bottom:15px; }
.p-desc p { font-size: 16px; line-height: 1.6; white-space: pre-wrap; margin:0;}
.p-img-box { padding: 10px; align-items: center; }
.p-img-box img { max-width: 100%; max-height: 300px; object-fit: contain; }
.p-link-container { text-align: left; margin-bottom: 40px; }
.p-link-btn { display: inline-block; border: 2px solid #fff; padding: 15px 30px; color: #fff; text-decoration: none; font-size: 18px; font-weight: bold; transition: 0.3s; }
.p-link-btn:hover { background-color: #fff; color: #000; }
.p-sub { text-align: center; font-size: 28px; margin: 40px 0 20px 0; }
.p-tech { padding: 40px; }
.p-tech ul { list-style-type: disc; padding-left: 20px; margin: 0; }
.p-tech li { font-size: 18px; line-height: 1.8; margin-bottom: 10px; }

@media screen and (max-width: 768px) {
  .p-row { flex-direction: column; gap: 20px; }
  .p-title { font-size: 28px; }
}
</style>